
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle  } from '@fortawesome/free-regular-svg-icons'

export default class WHint extends React.Component {
	constructor(props) {
		super(props);
		this.state = { showhint: false };
	}
	onMouseOver(e) {
		this.toshow = true;
		setTimeout(() => { if (this.toshow) { this.setState({ showhint: true }) } }, 350);
	}
	onMouseOut(e) {
		this.toshow = false;
		setTimeout(() => { if (!this.toshow) { this.setState({ showhint: false }) } }, 350);
	}
	render() {
		return (
			<div className="Hint" onMouseOver={this.onMouseOver.bind(this)} onMouseOut={this.onMouseOut.bind(this)}>
				<span className="HintIcon"><FontAwesomeIcon icon={faQuestionCircle} /></span>
				{ this.state.showhint ? <div className="HintMessage">{this.props.hint}</div> : '' }
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/whint.js